var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "313px",
    height: "176px",
    viewBox: "0 0 313 176",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "social impact") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 313,
    height: 176
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Phase-2-Re-design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "About-us/-desktop",
    transform: "translate(-1028.000000, -2269.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "component-/-card-/-spot-illustration-+-brand-accent-copy-3",
    transform: "translate(1028.000000, 2086.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "social-impact",
    transform: "translate(0.000000, 183.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "container"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.446046,30 C121.884898,30 115.579887,31.0976752 109.704916,33.1179364 C112.984816,40.3491246 114.812824,48.3776424 114.812824,56.8331089 C114.812824,82.0338467 98.5858794,103.448615 76,111.214499 C85.0416314,131.139662 105.122762,145 128.446046,145 C160.232631,145 186,119.256485 186,87.5006734 C186,55.7435147 160.232631,30 128.446046,30 M128.446046,39.6002811 C154.882067,39.6002811 176.389475,61.0891257 176.389475,87.5006734 C176.389475,113.912221 154.882067,135.399719 128.446046,135.399719 C112.947069,135.399719 98.5589176,127.874919 89.6426584,115.637524 C110.825177,103.996779 124.423349,81.5866956 124.423349,56.8331089 C124.423349,51.0834456 123.708862,45.4509574 122.293369,39.9908649 C124.32359,39.7309246 126.378078,39.6002811 128.446046,39.6002811",
    id: "Fill-1",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,33.785501 C100.959717,13.8603385 80.87589,0 57.5539542,0 C25.768717,0 0,25.7435147 0,57.5006734 C0,89.2564853 25.768717,115 57.5539542,115 C64.1164504,115 70.4214616,113.902325 76.2950844,111.882064 C73.0138363,104.652222 71.1885241,96.6223576 71.1885241,88.1668911 C71.1885241,62.9661533 87.4154687,41.5527317 110,33.785501",
    id: "Fill-3",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,57.6858498 C115,49.2408381 113.169987,41.2222471 109.882716,34 C87.2567298,41.757627 71,63.1445719 71,88.3154954 C71,96.7591619 72.8286626,104.779098 76.1159336,112 C98.7432702,104.242373 115,82.8554281 115,57.6858498",
    id: "Fill-5",
    fill: "#FFFFFF"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial);
export default __webpack_public_path__ + "static/media/social.f1064b79f6a0cd16fef8cb0e05279855.svg";
export { ForwardRef as ReactComponent };